import { Helmet } from 'react-helmet-async';
import * as R from 'Router/routes';
import { Card, Checkbox, Link } from 'components';
import usePSD2Consents from './usePSD2Consents';
import { TwButton } from 'components/TwButton/TwButton';
import H1 from 'components/H/H1';
import { useTranslation } from 'react-i18next';

function SkeletonConsent() {
  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          className="animate-pulse bg-background-accent h-4 w-full"
        />
      ))}
      <div className="animate-pulse bg-background-accent h-4 w-1/2 mb-7" />
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={i}
          className="animate-pulse bg-background-accent h-4 w-full"
        />
      ))}
      <div className="animate-pulse bg-background-accent h-4 w-1/3 mb-7" />
    </div>
  );
}

function PSD2Consents() {
  const { t } = useTranslation();
  const {
    confirm,
    consentAccepted,
    handleConsentChange,
    isLoading,
    isPending,
    consentHTMLContent,
    isManual,
  } = usePSD2Consents();

  return (
    <>
      <Helmet>
        <title>{t('psd2_consents:html_title')}</title>
      </Helmet>

      <H1 dataTest="psd2Consents-title">{t('psd2_consents:page_title')}</H1>

      <Card
        className="flex-col mb-6 rounded-none lg:rounded"
        dataTest="psd2Consents-card"
      >
        <Checkbox
          dataTest="psd2Consents-checkbox"
          name="consent"
          onChange={handleConsentChange}
          value={consentAccepted}
          expand
        >
          {isLoading && <SkeletonConsent />}
          <div
            className="leading-[1.75] mb-6"
            dangerouslySetInnerHTML={{
              __html: consentHTMLContent,
            }}
            data-test="psd2Consents-checkbox-text"
          />
        </Checkbox>
        <div className="mx-auto lg:mx-0 w-full flex justify-center lg:justify-start">
          <TwButton
            onClick={confirm}
            data-test="psd2Consents-button"
            disabled={
              !consentHTMLContent || isLoading || !consentAccepted || isPending
            }
            pending={isPending}
          >
            {t('psd2_banks:continue')}
          </TwButton>
        </div>
      </Card>

      {!sessionStorage.getItem('psd2Token') && (
        <Link
          className="flex text-primary mx-auto lg:mx-0 mb-10 hover:underline text-left w-fit"
          dataTest="psd2Consents-back"
          to={isManual ? R.MANUAL_PSD2_BANKS : R.PSD2_BANKS}
        >
          {t('psd2_guide:back')}
        </Link>
      )}
    </>
  );
}

export default PSD2Consents;
